module.exports = __webpack_public_path__ + "img/crazy.dd253cdc.png";